module.exports = __webpack_public_path__ + "img/5.f35c6bf4.jpg";